import React, { createContext, useContext, useState, useCallback } from "react";
import { content } from "../i18n/content";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState("ru");
  const [applyOpen, setApplyOpen] = useState(false);

  const toggleLang = useCallback(
    () => setLang((l) => (l === "ru" ? "kz" : "ru")),
    []
  );
  const openApply = useCallback(() => setApplyOpen(true), []);

  const c = content[lang];

  return (
    <AppContext.Provider
      value={{ lang, setLang, toggleLang, c, applyOpen, setApplyOpen, openApply }}
    >
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
}
